
export default {
    middleware: 'logout',
}
